(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ReleaseNotesController", ReleaseNotesController);

  /** @ngInject */
  function ReleaseNotesController($scope, userActions, layoutActions, $http) {
    var vm = this;
    var webAppReleaseNotesString = "";

    init();

    function init() {
      $scope.$on("destroy", function () {});
      fetchReleaseNotes();
      refreshNotes();
    }

    function refreshNotes() {
      layoutActions.showLoader();
      vm.promise = userActions.getReleaseNotes().then(function (data) {
        vm.releaseNotesData = data.split("\n");
        layoutActions.hideLoader();
      });
    }

    function fetchReleaseNotes(){
      $http.get('releaseNotesMerchant.txt')
        .then(function(response) {
          webAppReleaseNotesString = response.data;
          vm.merchantWebAppReleaseNotes = webAppReleaseNotesString.split("\n");
        })
        .catch(function() {
          webAppReleaseNotesString = 'Error loading release notes. Please try again later.';
        });
    }

  }
})();
